import React from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  Container,
  Typography,
} from '@mui/material';
import { getPolyglot } from '../../../i18n';
import useParseErrorMessage from '../../../handlingErrors/useParseErrorMessage';
import useWatchError from '../../../handlingErrors/useWatchError';
import StoerkIdDetails from '../StoerkIdDetails/StoerkIdDetails';
import Breadcrumb from '../../../theme/components/Breadcrumb/Breadcrumb';
import { useNavigationPath } from './navigation';
import { useCustomerDetailData } from './useCustomerDetailData';

function CustomerDetailPage() {
  const polyglot = getPolyglot();
  const parseErrorMessage = useParseErrorMessage();

  const {
    workspace,
    current,
    requestActive,
    isChildRoute,
    loading,
    isError,
    error,
    isReady,
  } = useCustomerDetailData();

  useWatchError(error);
  const sections = useNavigationPath({ workspace });

  return (
    <Container
      maxWidth="xl"
      sx={{ padding: { xs: 1, md: 2 }, height: '100%' }}
      disableGutters
    >
      <Breadcrumb sections={sections} />
      <Box mt={1}>
        <Typography variant="h1">
          {isChildRoute
            ? polyglot.t('stoerk_id.detail_page.title')
            : polyglot.t('stoerk_id.customer_list.title')}
        </Typography>
        {!isChildRoute && (
          <Typography variant="body2">
            {polyglot.t('stoerk_id.customer_list.note')}
          </Typography>
        )}

        <Box mt={2}>
          {loading && (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="100px"
            >
              <CircularProgress />
            </Box>
          )}

          {isError && (
            <Alert severity="error">{parseErrorMessage(error)}</Alert>
          )}

          {isReady && !loading && !isError && (
            <Container maxWidth="lg" disableGutters>
              <StoerkIdDetails
                workspace={workspace}
                workspaces={workspace ? [workspace] : []}
                requests={current?.requests}
                requestActive={requestActive}
                showAccountData
                showRequestInfo={requestActive?.requestStatus !== 'ACTIVE'}
                showBillingInfo
                showRequestWorkspaceActions={
                  requestActive?.requestStatus !== 'ACTIVE' &&
                  requestActive?.requestStatus !== 'REJECTED'
                }
                showWorkspaceActions
              />
            </Container>
          )}
        </Box>
      </Box>
    </Container>
  );
}

export default CustomerDetailPage;
